import { useRouter } from "next/router";
import Link from "next/link";
import { useTranslation } from "next-i18next";
import fallbackTranslation from "@/lib/dbTranslations";
// STYLE
import s from "./SideFilters.module.scss";

interface SideFilterProps {
  basePath: string;
  clothingProductsGroup: any;
  locale: string;
}

export default function SideFilters({ basePath, clothingProductsGroup, locale }: SideFilterProps) {
  const { t } = useTranslation(["common", "db-translations"]);
  const router = useRouter();

  return (
    <div className="pe-4 pt-2" style={{ minWidth: "15rem" }}>
      <h2 className="fs-6 fw-semibold mb-3">{t("common.shop-by-category")}</h2>
      <ul className="nobulletsul ps-0">
        {clothingProductsGroup
          .sort((a, b) => a[locale].localeCompare(b[locale]))
          .map(
            (listItem, i) =>
              listItem.active && (
                <li className={`py-2 ${s.li}`} key={i}>
                  <Link href={`/${basePath}/${listItem.key.toLowerCase()}?Page=1&orderBy=LATEST-ARRIVALS`} passHref>
                    <a className="py-2 fs-6 fw-normal">
                      {fallbackTranslation("clothing-product-group", "db-translations", listItem, t, router.locale)}
                    </a>
                  </Link>
                </li>
              )
          )}
      </ul>
    </div>
  );
}
